import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { drapcodeIcon } from '../custom/icon-library';
import { snakeCaseToTitleCase } from '../utils/api_utils';
import { PAGES, PROFILER } from '../utils/dashboardConstants';

const DashboardHeaderNav = ({
  title,
  titleIcon,
  activeTab,
  projectId,
  enableProfiler,
  enablePage,
  toggle,
}) => {
  return (
    <nav className="navbar navbar-expand-lg bg-primary">
      <div className="container">
        <div className="navbar-translate">
          <div className="navbar-brand">
            <i className={`wb ${drapcodeIcon(titleIcon)}`} size={'md'}></i>&nbsp;
            <span>{title}</span>
          </div>
        </div>
        <div className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            {enableProfiler && (
              <li className={`nav-item ${activeTab === PROFILER && 'active'}`}>
                <Link
                  to={`/dashboard/${projectId}/profiler`}
                  onClick={() => {
                    toggle(PROFILER);
                  }}
                  className="nav-link"
                >
                  <i className={`wb ${drapcodeIcon(PROFILER)}`}></i>{' '}
                  {snakeCaseToTitleCase(PROFILER)}
                </Link>
              </li>
            )}
            {enablePage && (
              <li className={`nav-item ${activeTab === PAGES && 'active'}`}>
                <Link
                  to={`/dashboard/${projectId}/pages`}
                  onClick={() => {
                    toggle(PAGES);
                  }}
                  className="nav-link"
                >
                  <i className={`wb ${drapcodeIcon(PAGES)}`}></i> {snakeCaseToTitleCase(PAGES)}
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default DashboardHeaderNav;
